module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "watermark"
    },
    slot: "watermark"
  }, [_c('div', {
    staticClass: "wm-toolbar"
  }, [_c('span', {
    staticClass: "wm-toolbar-text"
  }, [_vm._v("拖拽图片、粘贴或点击上传")]), _vm._v(" "), _c('v-upload', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "beforeShow": true,
      "uploadApi": '/static/data/editorUpload.json'
    },
    on: {
      "before": _vm.onUpload
    }
  }, [_c('v-button', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_vm._v("选择图片")])], 1), _vm._v(" "), (_vm.srcImage) ? _c('v-button', {
    staticClass: "wm-dl-btn",
    on: {
      "click": _vm.downloadImage
    }
  }, [_vm._v("下载水印图片")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wm-controls"
  }, [_c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("文字")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watermarkText),
      expression: "watermarkText"
    }],
    staticClass: "layui-input wm-input-text",
    attrs: {
      "placeholder": "水印文字"
    },
    domProps: {
      "value": (_vm.watermarkText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.watermarkText = $event.target.value
      }, _vm.onSettingChange]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("模式")]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "width": "90px",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.modeOptions
    },
    on: {
      "change": _vm.onSettingChange
    },
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("字号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fontSize),
      expression: "fontSize",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "layui-input wm-input-num",
    attrs: {
      "type": "number",
      "min": "8",
      "max": "600",
      "placeholder": String(_vm.defaultFontSize)
    },
    domProps: {
      "value": (_vm.fontSize)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.fontSize = _vm._n($event.target.value)
      }, _vm.onSettingChange],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wm-unit"
  }, [_vm._v("px")])]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("透明")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.opacity),
      expression: "opacity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "wm-range",
    attrs: {
      "type": "range",
      "min": "5",
      "max": "100"
    },
    domProps: {
      "value": (_vm.opacity)
    },
    on: {
      "input": _vm.onSettingChange,
      "__r": function($event) {
        _vm.opacity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wm-range-val"
  }, [_vm._v(_vm._s(_vm.opacity) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "wm-control-group"
  }, [_c('label', {
    staticClass: "wm-label"
  }, [_vm._v("颜色")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "wm-color",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.color)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.color = $event.target.value
      }, _vm.onSettingChange]
    }
  })])]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "drop-zone",
    class: {
      'drop-zone-active': _vm.dragOver
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDrop($event)
      }
    }
  }, [(_vm.srcImage) ? _c('img', {
    staticClass: "wm-preview",
    attrs: {
      "src": _vm.srcImage
    }
  }) : _c('div', {
    staticClass: "drop-placeholder"
  }, [_vm._v("拖拽图片到此处，或 Ctrl+V 粘贴")])]) : _c('div', {
    staticClass: "wm-preview-wrap"
  }, [(_vm.srcImage) ? _c('img', {
    staticClass: "wm-preview-m",
    attrs: {
      "src": _vm.srcImage
    }
  }) : _c('div', {
    staticClass: "wm-mobile-hint"
  }, [_vm._v("点击上方「选择图片」上传或从相册粘贴")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a847086!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/watermark.vue
// module id = 589
// module chunks = 2